import styled from 'styled-components';
import Box from '../../base/Box';

export const Avatar = styled(Box).attrs(({ bgColor }) => ({
  width: '28px',
  height: '28px',
  inline: true,
  align: 'center',
  justify: 'center',
  backgroundColor: bgColor,
}))`
  border-radius: 50%;
  font-size: 14px;
  color: white;
`;
